import type { FieldRendererProps } from '../../config/types';
import { DatePicker } from '@/components/ui/DatePicker';

export function DateFieldRenderer({ field, value, onChange, error }: FieldRendererProps) {
  return (
    <DatePicker
      id={field.id}
      value={(value as string) ?? ''}
      onValueChange={(v) => onChange(v)}
      placeholder={field.placeholder ?? 'Pick a date'}
      disabled={field.isDisabled}
      min={field.props?.min as string | undefined}
      max={field.props?.max as string | undefined}
      className={error ? 'border-danger/40' : ''}
    />
  );
}
